import { SWRConfiguration } from 'swr';

import { useSWR } from '@/hooks/useSwr';
import { getAgentMarketplacePath } from '@/utils/constants';

import { TAgentMarketplaceProject } from '../types';

type TGetAgentsResponse = {
  data: TAgentMarketplaceProject[];
  cursor: unknown;
};

export const useAgents = (options?: SWRConfiguration) => {
  const { data, isLoading, error } = useSWR<TGetAgentsResponse>(
    { url: getAgentMarketplacePath(), skipTenantHeaders: true },
    options
  );

  const agents = data?.data || [];

  return { data: agents, error, isLoading };
};

export const useAgent = (projectId: string, options?: SWRConfiguration) => {
  const { data, isLoading, error } = useSWR<TGetAgentsResponse>(
    {
      url: getAgentMarketplacePath() + `?id=${projectId}`,
      skipTenantHeaders: true,
    },
    options
  );

  const agent = data?.data ? data.data[0] : undefined;

  return { data: agent, error, isLoading };
};
